import React, { useEffect, useState, useCallback } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { Tooltip } from "@material-ui/core"
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import BuyWidget from "./BuyWidget"
import "./ProductCard.scss"

const ProductCard = ({ translation, product, onBuy }) => {
    const sizeTypes = {
        1: "мл",
        2: "мг",
        3: "г",
        4: "шт"
    }

    const [salePercent, setSalePercent] = useState(0)

    const handleSalePercent = useCallback(async () => {
        let result = await ((product.new_price / product.price) * 100).toFixed(2);
        setSalePercent(100 - result);
    }, [product.new_price, product.price])

    useEffect(() => {
        handleSalePercent()
    }, [handleSalePercent])

    const name = translation.translateKey(product, "name")

    return (
        <article key={product.id} className="Collection--item">
            <Link
                className="Collection--item--wrapper"
                to={"/products/" + product.id}
            >
                <div className="Collection--item--media">
                    <img
                        className="Collection--item--image"
                        src={process.env.REACT_APP_API + "/media/" + product.picture.split(",")[0]}
                        alt={name}
                        loading="lazy"
                    />
                    {(product.with_action === true || product.is_new === true) && (
                        <div className="Collection--item--badges">
                            {product.with_action === true && (
                                <span className="Collection--item--sale">
                                    <span className="visually-hidden">
                                        {translation.language === "ua" && "Акція!"}
                                        {translation.language === "ru" && "Акция!"}
                                    </span>
                                    −{Math.round(salePercent).toLocaleString()}%
                                </span>
                            )}
                            {product.is_new === true && (
                                <span className="Collection--item--sale new">
                                    {translation.language === "ua" && "Новинка"}
                                    {translation.language === "ru" && "Новинка"}
                                </span>
                            )}
                        </div>
                    )}
                </div>
                <div className="Collection--item--body">
                    {product.firm_ua &&
                        <p className="Collection--item--firm">
                            {translation.language === "ua" && product.firm_ua}
                            {translation.language === "ru" && product.firm_ru}
                        </p>
                    }
                    <h2 className="Collection--item--name">{name}</h2>
                    <p className="Collection--item--size">
                        {product.size.toLocaleString()} {sizeTypes[product.size_type]}
                        {product.additional_size !== 0 && <span><span> + </span> {product.additional_size} </span>}
                    </p>
                    {product.with_action === true
                        ?
                        <p className="Collection--item--price">
                            <span className="new_price">{product.new_price.toLocaleString()} грн</span>
                            <span className="sales_price">
                                <span className="visually-hidden">
                                    {translation.language === "ua" ? "Стара ціна: " : "Старая цена: "}
                                </span>
                                {product.price.toLocaleString()} грн
                            </span>
                        </p>
                        : <p className="Collection--item--price">{product.price.toLocaleString()} грн</p>}
                </div>
            </Link>
            {product.is_gift === true && (
                <Tooltip
                    title={translation.language === "ua" ? product.gift_ua || "" : product.gift_ru || ""}
                    placement="top"
                    enterTouchDelay={0}
                    arrow
                >
                    <span className="Collection--item--gift" tabIndex={0}>
                        <CardGiftcardIcon />
                        <span>
                            {translation.language === "ua" ? "Подарунок" : "Подарок"}
                        </span>
                    </span>
                </Tooltip>
            )}
            <BuyWidget available={product.is_available} product={product} onClick={onBuy} mode="card" />
        </article>
    )
}

const mapStateToProps = state => {
    return {
        translation: state.translationReducer
    }
}

export default connect(mapStateToProps)(ProductCard)
